import { ArticleHeading1 } from '@cian/ui-kit';
import * as React from 'react';

import { IRoomInfo } from '../../types/newobject/newbuildingRoomInfo';
import { RoomInfo } from './RoomInfo';
import * as styles from './newbuildingStats.css';

interface INewbuildingStats {
  subtitle: string;
  newbuildingFeatures: React.ReactElement | null;
  roomsInfo: IRoomInfo[];
}

export const NewbuildingStats = ({ newbuildingFeatures, subtitle, roomsInfo }: INewbuildingStats) => {
  return (
    <section className={styles['container']}>
      <div className={styles['title']}>
        <ArticleHeading1 as="h2">Ещё квартиры в жилом комплексе</ArticleHeading1>
      </div>
      {subtitle && (
        <div data-testid="newbuildingStatsSubtitle" className={styles['subtitle']}>
          {subtitle}
        </div>
      )}
      {newbuildingFeatures}
      <ul className={styles['rooms']}>
        {roomsInfo.map((item, index) => (
          <RoomInfo key={index} info={item} />
        ))}
      </ul>
    </section>
  );
};
